import { RoutesComponents } from "@/components/app-lite/RoutesComponents";
import { PortableVideo } from "components/UI/PortableVideo";
import { LiteHeader } from "../LiteHeader";
import "./AppContent.scss";

export const AppContent = () => {
  return (
    <div className="Wrapper">
      <div className="routeWrapper">
        <LiteHeader />
        <PortableVideo />
        <RoutesComponents />
      </div>
    </div>
  );
};
